function FooterComponent() {
  return (
    <>
      <div className="footer">Copyright © Indus Net Technologies</div>
    </>
  );
}

export default FooterComponent;
